import { Box, Container, Grid } from '@mui/material'
import React from 'react'
import errorpng from '../../assets/img/404.png'
import errorpng1 from '../../assets/img/errorpng1.png'
import McDonalds from '../../assets/img/McDonalds_Golden_Arches.png'
import { GridEx, PageWrapper, TypographyEx } from '../../styles'
import styled from '@emotion/styled'

const TypographyNew = styled(TypographyEx)`
    max-width: unset;
    margin: 0 auto;
    font-size: 20vw;
    line-height: 0.5;
    margin-top: 10%;
    
    span{
        font-size: 5vw;
    }

    @media (min-width: 1590px){ font-size: 367px; span{font-size: 100px;}}
    @media (max-width: 1200px){ font-size: 20vw; }

    @media (max-width: 900px){ font-size: 20vw; margin-top: 25px; }

    @media (max-width: 600px){ font-size: 20vw; }
`

const LeftImage = styled.img`
    position: absolute;
    bottom: 0;
    left: 0;
`

const RightImage = styled.img`
    max-width: 410px !important;
    position: absolute;
    bottom: 8%;
    right: 12%;
    @media (max-width: 900px){ display:none;}

`


const Error = () => {
  return (
    <PageWrapper bg="#C20D00" bgimg={McDonalds}>
        <Container maxWidth="xl">
            <Grid container>
                <GridEx xs={12} item style={{minHeight: 'calc( 100vh - 129px )'}}>
                    <TypographyNew variant="inherit" align="center">
                        404<br />
                        <span>Not Found</span>
                    </TypographyNew>
                    <LeftImage src={errorpng} alt="home-main-image" className='tokenomicsImg' />
                    <RightImage src={errorpng1} alt="home-main-image" className='tokenomicsImg' />
                </GridEx>
            </Grid>
        </Container>
    </PageWrapper>
  )
}

export default Error